import axios from "axios"
import { handleApiError } from "../utils/error-handler"

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api"

class PaymentRecoveryService {
  // Get payment recovery settings
  async getSettings(params = {}) {
    try {
      const response = await axios.get(`${API_URL}/payment-recovery/settings`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params,
      })
      return response.data
    } catch (error) {
      return handleApiError(error, "Failed to fetch payment recovery settings")
    }
  }

  // Update payment recovery settings
  async updateSettings(settingsData, params = {}) {
    try {
      const response = await axios.put(`${API_URL}/payment-recovery/settings`, settingsData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params,
      })
      return response.data
    } catch (error) {
      return handleApiError(error, "Failed to update payment recovery settings")
    }
  }

  // Get failed payments with optional filters
  async getFailedPayments(filters = {}) {
    try {
      // Convert filters object to query string
      const queryParams = new URLSearchParams()
      Object.keys(filters).forEach((key) => {
        if (filters[key] && filters[key] !== "all") {
          queryParams.append(key, filters[key])
        }
      })

      const response = await axios.get(`${API_URL}/payment-recovery/failed-payments?${queryParams.toString()}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      return response.data
    } catch (error) {
      return handleApiError(error, "Failed to fetch failed payments")
    }
  }

  // Retry a specific failed payment
  async retryPayment(paymentId, params = {}) {
    try {
      const response = await axios.post(
        `${API_URL}/payment-recovery/failed-payments/${paymentId}/retry`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          params,
        },
      )
      return response.data
    } catch (error) {
      return handleApiError(error, "Failed to retry payment")
    }
  }

  // Get payment recovery statistics
  async getPaymentRecoveryStats() {
    try {
      const response = await axios.get(`${API_URL}/payment-recovery/stats`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      return response.data
    } catch (error) {
      return handleApiError(error, "Failed to fetch payment recovery statistics")
    }
  }
}

export default new PaymentRecoveryService()

